import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FormInput from '../FormInput';

const CompoundConditionallyDisplay = ({ name, references, props }) => {
    const [display, setDisplay] = useState(false);
    const { watch, getValues } = useFormContext();
    const { referenceFields, referenceValues, all } = references;

    useEffect(() => {
        const values = getValues(referenceFields);
        if (all) {
            setDisplay(values.every((val, index) => (val?.value || val) === referenceValues[index]));
        } else {
            setDisplay(values.some((val, index) => (val?.value || val) === referenceValues[index]));
        }
    }, [...watch(referenceFields)]);

    if (!display) {
        return null;
    }

    return <FormInput name={name} props={props} />;
};

export default CompoundConditionallyDisplay;
